import React from "react";
import {Link} from "react-router-dom";

const Error404 = () => {
  return (
    <div className="authincation">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-8">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text font-weight-bold">404</h1>
              <h4>
                <i className="fa fa-exclamation-triangle text-warning" />
                Page introuvable !
              </h4>
              <p>
                L’adresse saisie est peut-être incorrecte ou la page a été
                déplacée.
              </p>
              <div>
                <Link className="btn btn-primary" to="/">
                  Retour à l'accueil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
